export const FeedbackTranslation = {
  fi: {
    Feedback: {
      message: 'Palaute',
    },
  },
};
